import { FetchDataMainParams, FetchDataSummaryParams, FetchReportFactoryParams, FetchDirectionsParams } from "../types/request";
import { BACKEND_URL, STRAPI_TOKEN } from "./config";

export const fetchFilters = async () => {
  const response = await fetch(`${BACKEND_URL}/api/gop-groups?populate[gops][populate]=*&populate[factories][populate]=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const fetchCurrentDate = async () => {
  const response = await fetch(`${BACKEND_URL}/api/gop-available-questionnaires`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const fetchDataMain = async (params: FetchDataMainParams) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/gop-data-main?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data;
};

export const fetchDataSummary = async (params: FetchDataSummaryParams) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/gop-data-summary?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data;
};

export const fetchReportFactory = async (params: FetchReportFactoryParams) => {
  try {
    const query = new URLSearchParams();

    params.year.forEach((year) => query.append("year", String(year)));
    params.quarter.forEach((quarter) => query.append("quarter", quarter));
    params.factory.forEach((factory) => query.append("factory", String(factory)));
    params.gop.forEach((gop) => query.append("gop", String(gop)));

    const response = await fetch(
      `${BACKEND_URL}/api/gop-report-factory?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${STRAPI_TOKEN}`,
          "Content-Type": "application/json",
        },
        credentials: 'include'
      }
    );

    if (!response.ok) {
      console.error("Ошибка ответа сервера:", response.statusText);
      return [];
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка при выполнении запроса:", error);
    return [];
  }
};

export const fetchDirections = async (params: FetchDirectionsParams) => {
  const response = await fetch(`${BACKEND_URL}/api/gop-directions?sort=order:asc&filters[gop][id][$in]=${params.gop}&populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const fetchSettings = async () => {
  const response = await fetch(`${BACKEND_URL}/api/gop-settings?populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const getCommentsOnly = async (params: FetchDataMainParams) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/gop-comments-only?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data;
};

export const getActionsOnly = async (params: FetchDataMainParams) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/gop-actions-only?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};
